import React from 'react';
import PropTypes from 'prop-types';
import { Text, Button } from '@nextiva/next-ui';
import { PaymentMethodList } from '.';
import { PURCHASE_LICENSE_FLOW_FLAG } from 'constant';
import { useFeature } from '@nextiva/feature-toggle';
import { Alert, styled } from '@nextiva/next-ui-components';

import './Payment.scss';

const StyledPaymentAlert = styled(Alert)`
  align-items: center;
  margin-bottom: 1.5rem;
`;

export const blockName = 'payment-page';

const Payment = props => {
  const { isEnabled } = useFeature({
    name: PURCHASE_LICENSE_FLOW_FLAG,
  });

  return (
    <div data-testid={blockName} className={`${blockName}`}>
      <div className={`${blockName}__title`}>
        <Text kind="h1" className={`${blockName}__title-text`}>
          Payment Details
        </Text>
        <Button
          kind="primary"
          className={`${blockName}--large-button`}
          onClick={props.toggleAddPaymentDrawer}
        >
          Add new
        </Button>
      </div>
      {isEnabled && (
        <StyledPaymentAlert severity="info" fullWidth>
          Updating your payment method will apply to all future charges.
        </StyledPaymentAlert>
      )}
      <PaymentMethodList
        startDeleteCreditCard={props.startDeleteCreditCard}
        startSetDefaultPayment={props.startSetDefaultPayment}
        corpAcctNbr={props.corpAcctNbr}
        nextInvoiceDate={props.nextInvoiceDate}
        paymentMethods={props.paymentMethods}
        billToSiteNumber={props.billToSiteNumber}
        addAlertDetails={props.addAlertDetails}
      />
    </div>
  );
};

Payment.propTypes = {
  startDeleteCreditCard: PropTypes.func.isRequired,
  startSetDefaultPayment: PropTypes.func.isRequired,
  paymentMethods: PropTypes.array.isRequired,
  nextInvoiceDate: PropTypes.string.isRequired,
  corpAcctNbr: PropTypes.number.isRequired,
  toggleAddPaymentDrawer: PropTypes.func.isRequired,
  billToSiteNumber: PropTypes.string.isRequired,
  addAlertDetails: PropTypes.func.isRequired,
};

export default Payment;
